<template>
  <div class="tab" v-if="!$isMobile">
    <div
      class="tab-item"
      :class="{ active: tab.value === value }"
      v-for="tab in data"
      :key="tab.value"
      @click="handleClickTab(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
  <div class="mobile" v-else>
    <div
      class="mobile-tab-item btn"
      :class="{ 'btn-view': tab.value === value }"
      v-for="tab in data"
      :key="tab.value"
      @click="handleClickTab(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "tab",
  props: {
    data: {
      type: Array
    },
    value: {
      type: String
    }
  },

  methods: {
    handleClickTab(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab {
  padding: 10px 0 25px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #ccc;

  &-item {
    color: #464646;
    font-size: 1.5rem;
    padding: 1rem 2.5rem;
    cursor: pointer;

    &.active {
      position: relative;
      background: #ececec;
      padding: 1rem 2.5rem;
      border-radius: 30px;
      box-shadow: 1px 2px 4px 1px #ccc;

      &:after,
      &::before {
        position: absolute;
        content: "";
        width: 14px;
        height: 14px;
        bottom: -8px;
        left: 50%;
        margin-left: -7px;
        overflow: hidden;
        pointer-events: none;
        -webkit-transform: rotate(45deg);
        -mz-transform: rotate(45deg);
        transform: rotate(45deg);
      }
      &:after {
        bottom: -7px;
        background: #ececec;
      }
      &:before {
        bottom: -7px;
        box-shadow: 3px 2px 2px 0px #ccc;
      }
    }
  }
}
.mobile {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
